/**
 * Shared button-editor constants.
 * Keep visual defaults identical to HomeLauncher ButtonAdminModal.
 */

export const COLOR_PRESETS = [
  '#e3f2fd', // light blue
  '#e8f5e9', // light green
  '#fff3e0', // light orange
  '#ffebee', // light red
  '#ede7f6', // light purple
  '#f5f5f5', // light grey
];

export const DEFAULT_ICON_BG = '#e3f2fd';

export const ICON_TYPE_BUILTIN = 'builtin';
export const ICON_TYPE_TEXT = 'text';
export const ICON_TYPE_IMAGE = 'image';
/** Editor-only. Saves as an image asset id, the same as an upload. */
export const ICON_TYPE_GENERATE = 'generate';

/** HomeLauncher action values (Phase 1). */
export const HOME_ACTION_FLOW = 'flow';
/** Run one Event System action without a Flow. */
export const HOME_ACTION_ACTION = 'action';
export const HOME_ACTION_PAGING = 'paging';
export const HOME_ACTION_SIP_PAGING = 'sipPaging';
export const HOME_ACTION_IMAGE_DISPLAY = 'imageDisplay';
export const HOME_ACTION_COLLABORATION = 'collaboration';
export const HOME_ACTION_CONTACT_LIST = 'contact_list';
/** Browser Phone overlay (Dial / Recents / Directory). */
export const HOME_ACTION_PHONE = 'phone';
/** Reminders & Timers overlay. */
export const HOME_ACTION_REMINDERS = 'reminders';
/** Email Reminder overlay — private inbound addresses. */
export const HOME_ACTION_EMAIL_REM = 'emailRem';
/** Opens the Home Ask SB sidebar. Not a Flow action. */
export const HOME_ACTION_ASK_SB = 'askSb';
/** Local navigation to Screen Saver (`/ambient`) — no Flow/MQTT. */
export const HOME_ACTION_OPEN_SCREEN_SAVER = 'openScreenSaver';
export const HOME_ACTION_NONE = 'none';
export const HOME_ACTION_EXTERNAL_LEGACY = 'external';
